module.exports = __webpack_public_path__ + "img/group2.ab15e592.png";